// extracted by mini-css-extract-plugin
export default {"affair":"Affair_affair__Pwp23","name":"Affair_name__fSyTa","closeButton":"Affair_closeButton__zjh47"};